// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fruits-text {
    font-size: 0.8rem !important;
    font-weight: 700 !important;
    color: #21C0FD !important;
    display: flex;
    justify-content: start;
    align-items: center;
}

.prod_InfoTag {
    display: flex;
    flex-direction: row;
    gap: 30px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.price-prod-box-flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 3rem;
}


.first-price-box {
    border-radius: 7px;
    margin-bottom: 10px;
}

.hidden-input {
    /* border: 1px solid lightgray; */
    border-radius: 7px;
    font-size: 0.7em !important;
    margin-left: 3px;
}

.bundle-imageStyle {
    width: 300px;
    height: 300px;
    border-radius: 50%;
}

.bundle-cardStyle {
    display: flex;
    justify-content: start;
}

.head-bundleStyle {
    font-size: 1.7rem !important;
    font-weight: bold !important;
    text-align: left !important;
}

.dark .head-bundleStyle {
    color: white !important;
}

.dark .product-details-table td {
    color: white !important;
}

.product-details-table {
    width: 100%;
}

.product-details-table th,
.product-details-table td {
    padding: 12px;
    border: 1px solid #ddd;
    text-align: center;
    white-space: nowrap;
}

.product-details-table th {
    background-color: #f2f2f2;
}

.product-details-table tbody tr:hover {
    background-color: #cdf2ef;
    color: black;
    font-weight: bold;
}

.prd-detail-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
}

.prd-detail-box {
    padding: 20px;
    border-radius: 10px;
    background-color: #0562fb;
    color: white;
    font-size: 20px;
    text-align: center;
    animation: pulse 2s infinite alternate;
}

@keyframes pulse {
    from {
        transform: scale(1);
    }

    to {
        transform: scale(1.1);
    }
}

.product-details-table-scroll {
    max-height: 300px;
    overflow-y: auto;
}

.product-details-batches-box {
    overflow: scroll;
    height: 33rem;
    padding-bottom: 1rem;
}

.no-data-found-prd {
    text-align: center;
    font-size: 1.3rem;
    padding: 1rem;
    margin: 1rem auto;
    border-radius: 5px;
    background-color: #e0f2ff;
    color: #333;
    font-weight: bold;
}


.product-details-batches-box::-webkit-scrollbar {
    width: 5px;
}

.product-details-batches-box::-webkit-scrollbar-track {
    background: transparent;
}

.product-details-batches-box::-webkit-scrollbar-thumb {
    background-color: rgba(155, 155, 155, 0.7);
    border-radius: 20px;
    border: transparent;
}

.product-details-batches-box::-webkit-scrollbar-thumb:hover {
    background: #8d8d8d;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/productDetail/components/productDetailInfo/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".fruits-text {\n    font-size: 0.8rem !important;\n    font-weight: 700 !important;\n    color: #21C0FD !important;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n}\n\n.prod_InfoTag {\n    display: flex;\n    flex-direction: row;\n    gap: 30px;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.price-prod-box-flex {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    margin-top: 3rem;\n}\n\n\n.first-price-box {\n    border-radius: 7px;\n    margin-bottom: 10px;\n}\n\n.hidden-input {\n    /* border: 1px solid lightgray; */\n    border-radius: 7px;\n    font-size: 0.7em !important;\n    margin-left: 3px;\n}\n\n.bundle-imageStyle {\n    width: 300px;\n    height: 300px;\n    border-radius: 50%;\n}\n\n.bundle-cardStyle {\n    display: flex;\n    justify-content: start;\n}\n\n.head-bundleStyle {\n    font-size: 1.7rem !important;\n    font-weight: bold !important;\n    text-align: left !important;\n}\n\n.dark .head-bundleStyle {\n    color: white !important;\n}\n\n.dark .product-details-table td {\n    color: white !important;\n}\n\n.product-details-table {\n    width: 100%;\n}\n\n.product-details-table th,\n.product-details-table td {\n    padding: 12px;\n    border: 1px solid #ddd;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.product-details-table th {\n    background-color: #f2f2f2;\n}\n\n.product-details-table tbody tr:hover {\n    background-color: #cdf2ef;\n    color: black;\n    font-weight: bold;\n}\n\n.prd-detail-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50vh;\n}\n\n.prd-detail-box {\n    padding: 20px;\n    border-radius: 10px;\n    background-color: #0562fb;\n    color: white;\n    font-size: 20px;\n    text-align: center;\n    animation: pulse 2s infinite alternate;\n}\n\n@keyframes pulse {\n    from {\n        transform: scale(1);\n    }\n\n    to {\n        transform: scale(1.1);\n    }\n}\n\n.product-details-table-scroll {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.product-details-batches-box {\n    overflow: scroll;\n    height: 33rem;\n    padding-bottom: 1rem;\n}\n\n.no-data-found-prd {\n    text-align: center;\n    font-size: 1.3rem;\n    padding: 1rem;\n    margin: 1rem auto;\n    border-radius: 5px;\n    background-color: #e0f2ff;\n    color: #333;\n    font-weight: bold;\n}\n\n\n.product-details-batches-box::-webkit-scrollbar {\n    width: 5px;\n}\n\n.product-details-batches-box::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.product-details-batches-box::-webkit-scrollbar-thumb {\n    background-color: rgba(155, 155, 155, 0.7);\n    border-radius: 20px;\n    border: transparent;\n}\n\n.product-details-batches-box::-webkit-scrollbar-thumb:hover {\n    background: #8d8d8d;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
